export default class Country {
  public static readonly SET_DATA = "PROFILE_SET_DATA";
  public static readonly SET_STATUS = "PROFILE_SET_STATUS";
  public static readonly SET_ERROR = "PROFILE_SET_ERROR";
  public static readonly CLEAR = "PROFILE_CLEAR";

  public static setData(data: any) {
    return {
      data,
      type: Country.SET_DATA,
    };
  }

  public static setStatus(data: any) {
    return {
      data,
      type: Country.SET_STATUS,
    };
  }

  public static setError(data: any) {
    return {
      data,
      type: Country.SET_ERROR,
    };
  }

  public static clear() {
    return {
      type: Country.CLEAR,
    };
  }
}
